import awards from "../../shared/it.awards";
import branded_quotes from "../../shared/it.branded-quotes";
import verticals from "./it-enterprise.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};
export default ({ page, strings }) => {
    switch (page) {
        case "it-enterprise-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contatti | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.it/aziende/contatti/",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-enterprise-home":
            return {
                page,
                helmet: {
                    meta_title: "Formazione linguistica per le imprese | Rosetta Stone",
                    meta_description:
                        "Le soluzioni di formazione Rosetta Stone aiutano i dipendenti ad acquisire competenze linguistiche in inglese per le imprese ed in molte altre lingue straniere. Richiedete le nostre tariffe.",
                    canonical_url: "https://www.rosettastone.it/aziende/",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-enterprise-solutions":
            return {
                page,
                helmet: {
                    meta_title: "Formazione linguistica per le imprese  mondiali | Rosetta Stone Catalyst",
                    meta_description:
                        "La Formazione linguistica per le imprese mondiali con Rosetta Stone Catalyst offre corsi nelle principali lingue commerciali che i dipendenti possono apprendere ovunque si trovino. Richiedi le nostre tariffe per le aziende.",
                    canonical_url: "https://www.rosettastone.it/aziende/soluzioni/",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-enterprise-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-enterprise-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        case "it-enterprise-404":
            return {
                page,
                helmet: {
                    meta_title: "Sito non trovato | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.it/aziende/404",
                    lang: "it"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
